import script from "./usb-policy.vue?vue&type=script&lang=ts&setup=true"
export * from "./usb-policy.vue?vue&type=script&lang=ts&setup=true"

import "./usb-policy.vue?vue&type=style&index=0&id=256ece22&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256ece22"]])

export default __exports__